import { motion } from "framer-motion";
import { FrogFace } from "@/components/FrogArt";
import { Waves } from "lucide-react";

export const FrogPond = ({ logs = [] }) => {
  const byDay = {};
  logs.forEach((l) => (byDay[l.day_number] = l));

  return (
    <div data-testid="frog-pond" className="relative rounded-3xl bg-sky-100 border-4 border-sky-200 p-6 overflow-hidden">
      <svg className="absolute inset-x-0 bottom-0 w-full h-16 opacity-40" viewBox="0 0 400 40" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 20 Q50 5 100 20 T200 20 T300 20 T400 20 V40 H0 Z" fill="#38BDF8" />
      </svg>
      <p className="font-display font-semibold text-slate-700 mb-4 text-sm uppercase tracking-widest">Your 14-Day Pond</p>
      <div className="relative grid grid-cols-7 gap-3">
        {Array.from({ length: 14 }, (_, i) => {
          const day = i + 1;
          const log = byDay[day];
          const done = log?.status === "done";
          const reset = log?.status === "reset";
          return (
            <motion.div
              key={day}
              data-testid={`pond-day-${day}`}
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.04 }}
              className={`aspect-square rounded-full flex items-center justify-center relative ${
                done ? "bg-green-300" : reset ? "bg-sky-200" : log ? "bg-yellow-200" : "bg-white/70"
              } border-2 ${done ? "border-green-400" : "border-sky-200"}`}
            >
              {done ? (
                <motion.div initial={{ y: -8 }} animate={{ y: 0 }} transition={{ type: "spring", stiffness: 300 }}>
                  <FrogFace size={30} />
                </motion.div>
              ) : reset ? (
                <Waves className="w-5 h-5 text-sky-500" />
              ) : (
                <span className={`font-display font-bold ${log ? "text-yellow-700" : "text-slate-400"} text-sm`}>{day}</span>
              )}
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
